















import Vue from 'vue';
import Component from 'vue-class-component';

const Setup = Vue.extend({
	name: 'FormInputWithIcon',
	inheritAttrs: false,
	props: {
		icon: [Array, String],
		iconSize: { type: String, default: '' },
	},
});

@Component
export default class FormInputWithIcon extends Setup {
	public icon!: string[] | string;
	public iconSize!: string;
}
